import React from 'react';
import React$1, { useMemo, useState, useReducer, useEffect, useCallback, createContext, useContext, Children, forwardRef, useRef, Fragment } from 'react';
import { useWallet, useAnchorWallet, ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { Connection, PublicKey, Transaction } from '@solana/web3.js';
import { AnchorProvider, setProvider } from '@coral-xyz/anchor';
import { createUmi } from '@metaplex-foundation/umi-bundle-defaults';
import { mplCandyMachine } from '@metaplex-foundation/mpl-candy-machine';
import { walletAdapterIdentity } from '@metaplex-foundation/umi-signer-wallet-adapters';
import { Metaplex, walletAdapterIdentity as walletAdapterIdentity$1 } from '@metaplex-foundation/js';
import { Magic } from 'magic-sdk';
import { SolanaExtension } from '@magic-ext/solana';
import { useTranslation, initReactI18next } from 'react-i18next';
import { styled, Button as Button$1, IconButton as IconButton$1, DialogActions, Box, Typography, Dialog as Dialog$1, Slide, ListItem, List, Collapse, TextField } from '@mui/material';
import { WalletReadyState } from '@solana/wallet-adapter-base';
import jazzicon from '@metamask/jazzicon';
import { MuiOtpInput } from 'mui-one-time-password-input';
import i18n from 'i18next';
import { useAsync } from 'react-async-hook';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function magicReducer(state, action) {
  switch (action.type) {
    case "start":
      return {
        didToken: null,
        metadata: null,
        error: null,
        magicAuthenticationStatus: "pending"
      };
    case "set-session":
      return {
        didToken: action.token,
        metadata: action.meta,
        error: null,
        magicAuthenticationStatus: "authenticated"
      };
    case "remove-session":
      return {
        didToken: null,
        metadata: null,
        error: null,
        magicAuthenticationStatus: "unauthenticated"
      };
    case "error":
      return {
        didToken: null,
        metadata: null,
        error: action.error,
        magicAuthenticationStatus: "errored"
      };
    case "login-code":
      return {
        didToken: null,
        metadata: {
          email: action.email,
          issuer: null,
          publicAddress: null
        },
        error: null,
        magicAuthenticationStatus: "authenticationCode"
      };
    case "invalid-code":
      return {
        didToken: null,
        metadata: null,
        error: null,
        magicAuthenticationStatus: "invalid-code"
      };
    case "restart-session":
      return {
        didToken: null,
        metadata: null,
        error: null,
        magicAuthenticationStatus: "unauthenticated"
      };
    default:
      return state;
  }
}

var defaultContextValues = {
  login: function login() {},
  cancel: function cancel() {},
  logout: function logout() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  },
  refresh: function refresh() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  },
  handleLoginCode: function handleLoginCode() {},
  restartSession: function restartSession() {},
  magicAuthenticationStatus: "unauthenticated",
  metadata: {
    issuer: null,
    email: null,
    publicAddress: null
  },
  error: null,
  magic: undefined
};
var MagicContext = /*#__PURE__*/createContext(defaultContextValues);
var MagicProvider = function MagicProvider(_ref) {
  var solanaRpcHost = _ref.solanaRpcHost,
    magicKey = _ref.magicKey,
    children = _ref.children;
  var magic = useMemo(function () {
    return typeof window !== "undefined" && new Magic(magicKey, {
      extensions: [new SolanaExtension({
        rpcUrl: solanaRpcHost
      })]
    });
  }, []);
  var _useState = useState(defaultContextValues),
    _useState2 = _slicedToArray(_useState, 2),
    contextValues = _useState2[0],
    setContextValues = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    loginObj = _useState4[0],
    setLoginObj = _useState4[1];
  var _useReducer = useReducer(magicReducer, {
      didToken: null,
      metadata: null,
      error: null,
      magicAuthenticationStatus: "unauthenticated"
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(function () {
    function checkAuthenticationStatus() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var isLoggedIn, _yield$Promise$all, _yield$Promise$all2, meta, token;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (magic) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.prev = 2;
              _context3.next = 5;
              return magic.user.isLoggedIn();
            case 5:
              isLoggedIn = _context3.sent;
              if (!isLoggedIn) {
                _context3.next = 21;
                break;
              }
              dispatch({
                type: "start"
              });
              _context3.next = 10;
              return Promise.all([magic.user.getMetadata(), magic.user.getIdToken()]);
            case 10:
              _yield$Promise$all = _context3.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              meta = _yield$Promise$all2[0];
              token = _yield$Promise$all2[1];
              if (token) {
                _context3.next = 18;
                break;
              }
              _context3.next = 17;
              return magic.user.generateIdToken();
            case 17:
              token = _context3.sent;
            case 18:
              dispatch({
                type: "set-session",
                token: token,
                meta: meta
              });
              _context3.next = 22;
              break;
            case 21:
              dispatch({
                type: "remove-session"
              });
            case 22:
              _context3.next = 32;
              break;
            case 24:
              _context3.prev = 24;
              _context3.t0 = _context3["catch"](2);
              if (!(_context3.t0 instanceof Error)) {
                _context3.next = 31;
                break;
              }
              console.error("MAGIC Error: ", _context3.t0.message);
              dispatch({
                type: "error",
                error: _context3.t0
              });
              _context3.next = 32;
              break;
            case 31:
              throw _context3.t0;
            case 32:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 24]]);
      }));
    }
    checkAuthenticationStatus();
  }, [magic]);
  var handleLogin = useCallback(function (configuration) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var login;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (magic) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return");
          case 2:
            dispatch({
              type: "start"
            });
            login = magic.auth.loginWithEmailOTP(Object.assign({}, configuration));
            login.on("email-otp-sent", function () {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      setLoginObj(login);
                      dispatch({
                        type: "login-code",
                        email: configuration.email
                      });
                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
            }).on("invalid-email-otp", function () {
              dispatch({
                type: "invalid-code"
              });
            }).on("done", function (result) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                var meta;
                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return magic.user.getMetadata();
                    case 2:
                      meta = _context5.sent;
                      dispatch({
                        type: "set-session",
                        token: result,
                        meta: meta
                      });
                    case 4:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }));
            }).on("error", function (error) {
              if (error instanceof Error) {
                console.error("MAGIC Error: ", error.message);
                dispatch({
                  type: "error",
                  error: error
                });
              } else {
                throw error;
              }
              login.emit("cancel");
            })["catch"](function () {
              login.emit("cancel");
            });
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
  }, [magic]);
  var handleLoginCode = useCallback(function (code) {
    dispatch({
      type: "start"
    });
    loginObj === null || loginObj === void 0 ? void 0 : loginObj.emit("verify-email-otp", code);
  }, [loginObj]);
  var handleCancelLogin = useCallback(function () {
    dispatch({
      type: "remove-session"
    });
    loginObj === null || loginObj === void 0 ? void 0 : loginObj.emit("cancel");
  }, [loginObj]);
  var handleLogoout = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            dispatch({
              type: "start"
            });
            if (magic) {
              _context7.next = 3;
              break;
            }
            return _context7.abrupt("return");
          case 3:
            _context7.prev = 3;
            _context7.next = 6;
            return magic.user.logout();
          case 6:
            dispatch({
              type: "remove-session"
            });
            _context7.next = 17;
            break;
          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](3);
            if (!(_context7.t0 instanceof Error)) {
              _context7.next = 16;
              break;
            }
            console.error("MAGIC Error: ", _context7.t0.message);
            dispatch({
              type: "error",
              error: _context7.t0
            });
            _context7.next = 17;
            break;
          case 16:
            throw _context7.t0;
          case 17:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[3, 9]]);
    }));
  }, [magic]);
  var restartSession = function restartSession() {
    dispatch({
      type: "restart-session"
    });
  };
  // Context consumer rerender fix
  // https://reactjs.org/docs/context.html#caveats
  useEffect(function () {
    setContextValues(function (prevValues) {
      return Object.assign(Object.assign(Object.assign({}, prevValues), state), {
        login: handleLogin,
        logout: handleLogoout,
        cancel: handleCancelLogin,
        handleLoginCode: handleLoginCode,
        restartSession: restartSession,
        magic: magic
      });
    });
  }, [state, handleLogin, handleLogoout, magic, handleCancelLogin, handleLoginCode]);
  return /*#__PURE__*/React$1.createElement(MagicContext.Provider, {
    value: contextValues
  }, children);
};

function useMagic() {
  var contextValues = useContext(MagicContext);
  return contextValues;
}

var SolanaRPCContext = /*#__PURE__*/createContext(null);

var useSolanaRPC = function useSolanaRPC() {
  return useContext(SolanaRPCContext);
};

var useSolana = function useSolana() {
  var solanaRpcHost = useSolanaRPC();
  var SolanaWallet = useWallet();
  var MagicWallet = useMagic();
  var web3AdapterAnchorWallet = useAnchorWallet();
  var connection = useMemo(function () {
    return new Connection(solanaRpcHost || "", {
      commitment: "confirmed"
    });
  }, []);
  var anchorProvider = useMemo(function () {
    var _a;
    var wallet = !((_a = MagicWallet === null || MagicWallet === void 0 ? void 0 : MagicWallet.metadata) === null || _a === void 0 ? void 0 : _a.publicAddress) ? web3AdapterAnchorWallet : {
      signTransaction: function signTransaction(transaction) {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _b, tx, rawTransaction, signedTransaction;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(MagicWallet.magic === false)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", undefined);
              case 2:
                _context.next = 4;
                return (_b = MagicWallet.magic) === null || _b === void 0 ? void 0 : _b.solana.signTransaction(transaction);
              case 4:
                tx = _context.sent;
                rawTransaction = tx.rawTransaction;
                signedTransaction = Transaction.from(rawTransaction);
                return _context.abrupt("return", signedTransaction);
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
      },
      signAllTransactions: function signAllTransactions(transactions) {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var txs;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Promise.all(transactions.map(function (tx) {
                  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                    var _c, signedTx, rawTransaction, signedTransaction;
                    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(MagicWallet.magic === false)) {
                            _context2.next = 2;
                            break;
                          }
                          return _context2.abrupt("return", undefined);
                        case 2:
                          _context2.next = 4;
                          return (_c = MagicWallet.magic) === null || _c === void 0 ? void 0 : _c.solana.signTransaction(tx);
                        case 4:
                          signedTx = _context2.sent;
                          rawTransaction = signedTx.rawTransaction;
                          signedTransaction = Transaction.from(rawTransaction);
                          return _context2.abrupt("return", signedTransaction);
                        case 8:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2);
                  }));
                }));
              case 2:
                txs = _context3.sent;
                return _context3.abrupt("return", txs);
              case 4:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
      },
      get publicKey() {
        var _a;
        return new PublicKey((_a = MagicWallet.metadata) === null || _a === void 0 ? void 0 : _a.publicAddress);
      }
    };
    var provider = new AnchorProvider(connection, wallet, {
      preflightCommitment: "confirmed",
      skipPreflight: true
    });
    return provider;
  }, [MagicWallet, connection, web3AdapterAnchorWallet]);
  var connect = useCallback(function (_ref) {
    var walletName = _ref.walletName,
      email = _ref.email;
    var select = SolanaWallet.select;
    var login = MagicWallet.login;
    if (walletName) {
      select(walletName);
    } else if (email) {
      login({
        email: email,
        showUI: false
      });
    }
  }, [MagicWallet, SolanaWallet]);
  var disconnect = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var connected, walletDisconnect, logout;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            connected = SolanaWallet.connected, walletDisconnect = SolanaWallet.disconnect;
            logout = MagicWallet.logout;
            if (!connected) {
              _context4.next = 7;
              break;
            }
            _context4.next = 5;
            return walletDisconnect();
          case 5:
            _context4.next = 9;
            break;
          case 7:
            _context4.next = 9;
            return logout();
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
  }, [MagicWallet, SolanaWallet]);
  var getPublicAddress = useCallback(function () {
    var publicKey = SolanaWallet.publicKey;
    var metadata = MagicWallet.metadata;
    if (publicKey) {
      return publicKey;
    }
    if (metadata && (metadata === null || metadata === void 0 ? void 0 : metadata.publicAddress)) {
      return new PublicKey(metadata.publicAddress);
    }
    return;
  }, [MagicWallet, SolanaWallet]);
  var getLoading = useCallback(function () {
    var connecting = SolanaWallet.connecting;
    var magicAuthenticationStatus = MagicWallet.magicAuthenticationStatus;
    return connecting || magicAuthenticationStatus === "pending";
  }, [MagicWallet, SolanaWallet]);
  var getConnected = useCallback(function () {
    var connected = SolanaWallet.connected;
    var magicAuthenticationStatus = MagicWallet.magicAuthenticationStatus;
    return connected || magicAuthenticationStatus === "authenticated";
  }, [MagicWallet, SolanaWallet]);
  var umi = useMemo(function () {
    var u = createUmi(solanaRpcHost || "").use(mplCandyMachine()).use(walletAdapterIdentity(anchorProvider, true));
    return u;
  }, [anchorProvider]);
  var metaplex = useMemo(function () {
    return new Metaplex(connection);
  }, [connection]);
  setProvider(anchorProvider);
  metaplex.use(walletAdapterIdentity$1(anchorProvider));
  return Object.assign(Object.assign(Object.assign({}, MagicWallet), SolanaWallet), {
    publicKey: getPublicAddress(),
    connecting: getLoading(),
    connected: getConnected(),
    connect: connect,
    disconnect: disconnect,
    anchorProvider: anchorProvider,
    umi: umi,
    metaplex: metaplex
  });
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "SET_DIALOG_STATE":
      return action.value;
    default:
      return state;
  }
};

var ConnectWalletContext = /*#__PURE__*/createContext({
  walletDialogState: undefined,
  updateWalletDialogState: function updateWalletDialogState(_) {}
});
var ConnectWalletProvider = function ConnectWalletProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(reducer, "logIn"),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    walletDialogState = _useReducer2[0],
    dispatch = _useReducer2[1];
  var updateWalletDialogState = function updateWalletDialogState(state) {
    dispatch({
      type: "SET_DIALOG_STATE",
      value: state
    });
  };
  var value = useMemo(function () {
    return {
      walletDialogState: walletDialogState,
      updateWalletDialogState: updateWalletDialogState
    };
  }, [walletDialogState]);
  return /*#__PURE__*/React$1.createElement(ConnectWalletContext.Provider, {
    value: value
  }, children);
};

var Button = styled(Button$1)({
  textTransform: "none",
  color: "hsl(220, 9%, 7%) !important",
  minWidth: "unset",
  fontWeight: 600,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  background: "hsl(210, 17%, 95%) !important",
  border: "1px solid hsl(210, 12%, 83%)",
  borderRadius: "62rem",
  "&:disabled": {
    opacity: 0.6
  },
  "&:hover": {
    backgroundColor: "hsl(216, 14%, 93%) !important",
    borderColor: "var(--dewi_colors_gray_5)",
    color: "hsl(214, 9%, 15%)"
  },
  "&:active": {
    backgroundColor: "hsl(210, 12%, 83%) !important",
    color: "hsl(220, 9%, 7%) !important"
  },
  "&:focus": {
    color: "hsl(214, 9%, 15%) !important",
    outline: "4px solid hsl(214, 61%, 53%)"
  }
});
var IconButton = styled(IconButton$1)({
  background: "#212121",
  color: "#D9D9D9",
  border: "1px solid #414141",
  "&:disabled": {
    opacity: 0.6
  },
  "&:hover": {
    background: "#212121"
  },
  "&:focus": {
    outline: "2px solid hsl(214, 61%, 53%)"
  }
});

var ArrowBack = function ArrowBack() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: "24",
    width: "24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "17.77,3.77 16,2 6,12 16,22 17.77,20.23 9.54,12"
  })));
};

var Close = function Close() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }));
};

var Sparkle = function Sparkle(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 23 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#fff" : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9219 4.50757C14.793 4.42163 14.707 4.33569 14.707 4.20679C14.707 4.03491 14.793 3.94897 14.9219 3.86304L17.5 2.78882L18.5312 0.253662C18.6172 0.124756 18.7031 0.0388184 18.832 0.0388184C19.0039 0.0388184 19.0898 0.124756 19.1758 0.253662L20.25 2.78882L22.7852 3.86304C22.9141 3.94897 23 4.03491 23 4.16382C23 4.33569 22.9141 4.42163 22.7852 4.50757L20.25 5.53882L19.1758 8.11694C19.0898 8.24585 19.0039 8.33179 18.875 8.33179C18.7031 8.33179 18.6172 8.24585 18.5312 8.11694L17.5 5.53882L14.9219 4.50757ZM22.7852 17.613C22.9141 17.699 23 17.7849 23 17.9138C23 18.0857 22.9141 18.1716 22.7852 18.2576L20.25 19.2888L19.1758 21.8669C19.0898 21.9958 19.0039 22.0818 18.875 22.0818C18.7031 22.0818 18.6172 21.9958 18.5312 21.8669L17.5 19.2888L14.9219 18.2576C14.793 18.1716 14.707 18.0857 14.707 17.9568C14.707 17.7849 14.793 17.699 14.9219 17.613L17.5 16.5388L18.5312 14.0037C18.6172 13.8748 18.7031 13.7888 18.832 13.7888C19.0039 13.7888 19.0898 13.8748 19.1758 14.0037L20.25 16.5388L22.7852 17.613ZM17.5 11.0388C17.457 11.4685 17.2422 11.8123 16.8984 11.9841L12.3867 14.2185L10.1523 18.7302C9.98047 19.074 9.63672 19.3318 9.25 19.3318C8.82031 19.3318 8.47656 19.074 8.30469 18.7302L6.07031 14.2185L1.55859 11.9841C1.21484 11.8123 0.957031 11.4685 0.957031 11.0818C0.957031 10.6521 1.21484 10.3083 1.55859 10.1365L6.07031 7.9021L8.30469 3.39038C8.64844 2.70288 9.80859 2.70288 10.1523 3.39038L12.3867 7.9021L16.8984 10.1365C17.2422 10.3083 17.457 10.6521 17.5 11.0388ZM11.1836 12.5427L14.1484 11.0388L11.1836 9.57788C10.9688 9.49194 10.7969 9.32007 10.7109 9.10522L9.25 6.14038L7.74609 9.10522C7.66016 9.32007 7.48828 9.49194 7.27344 9.57788L4.30859 11.0388L7.27344 12.5427C7.48828 12.6287 7.66016 12.8005 7.74609 13.0154L9.25 15.9802L10.7109 13.0154C10.7969 12.8005 10.9688 12.6287 11.1836 12.5427Z",
    fill: color
  }));
};

var MailOutline = function MailOutline(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 23 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#fff" : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
  }));
};

var ArrowFoward = function ArrowFoward() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h24v24H0V0z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "6.23,20.23 8,22 18,12 8,2 6.23,3.77 14.46,12"
  })));
};

// @flow
var WalletOutline = function WalletOutline(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#fff" : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16",
    height: size,
    width: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M14 3.5V3a2 2 0 0 0-2-2H3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h11a2 2 0 0 0 2-2V5.5a2 2 0 0 0-2-2zm.5 9.5a.5.5 0 0 1-.5.5H3c-.827 0-1.5-.673-1.5-1.5V4c0-.827.673-1.5 1.5-1.5h9a.5.5 0 0 1 .5.5v1h-9a.5.5 0 1 0 0 1H14a.5.5 0 0 1 .5.5V13zM12 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }));
};

var ArrowDropDown = function ArrowDropDown() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10l5 5 5-5z",
    fill: "#fff"
  }));
};

var ArrowDropUp = function ArrowDropUp() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14l5-5 5 5z",
    fill: "#fff"
  }));
};

var ChangeWallet = function ChangeWallet() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "35",
    height: "35",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1368_1937)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "34",
    height: "34",
    rx: "17",
    fill: "#2C2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5775 13.5727C25.6637 13.7013 26.4571 14.7078 26.3286 15.7939L25.4471 23.242C25.3148 24.3592 24.312 25.1216 23.2259 24.993L12.3021 23.7001C10.6263 23.5018 9.47716 22.0441 9.67551 20.3683L10.6158 12.4238C10.8105 10.779 12.2718 9.59882 13.9476 9.79716L22.8852 10.855C23.9714 10.9835 24.7648 11.99 24.6363 13.0762L24.5775 13.5727ZM23.9575 23.0656L24.839 15.6176C24.8684 15.3694 24.6495 15.0917 24.4012 15.0623L13.974 13.8282C13.6947 13.7951 13.5032 13.5522 13.5362 13.2729C13.5656 13.0246 13.8122 12.8021 14.0915 12.8351L23.0292 13.893L23.1467 12.8999C23.1761 12.6516 22.9572 12.374 22.7089 12.3446L13.7713 11.2868C12.9334 11.1876 12.2009 11.7932 12.1054 12.6001L11.1651 20.5446C11.0659 21.3825 11.6405 22.1113 12.4784 22.2105L23.4022 23.5034C23.6504 23.5328 23.9244 23.3449 23.9575 23.0656ZM22.0625 17.8065C22.59 17.8689 23.0004 18.3895 22.938 18.9171C22.8719 19.4757 22.355 19.855 21.8274 19.7926C21.2688 19.7265 20.8858 19.2406 20.9519 18.682C21.0143 18.1544 21.5039 17.7403 22.0625 17.8065Z",
    fill: "#CFD4D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3.19434",
    y: "14.5",
    width: "20.4307",
    height: "15.4756",
    transform: "rotate(6.28556 3.19434 14.5)",
    fill: "#2C2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4358 17.9444L10.4725 17.6341C10.5024 17.3819 10.7216 17.1915 10.9931 17.2237L18.383 18.0983L17.8631 17.5057C17.6921 17.2888 17.7265 16.9979 17.9434 16.8269L18.1603 16.6559C18.3773 16.4849 18.6682 16.5193 18.8198 16.7339L20.2414 18.5149C20.466 18.7775 20.4178 19.1848 20.1381 19.3877L18.34 20.7877C18.1425 20.961 17.8516 20.9265 17.6806 20.7096L17.5095 20.4927C17.3385 20.2758 17.373 19.9848 17.5899 19.8138L18.236 19.3396L10.8462 18.465C10.5747 18.4328 10.4037 18.2159 10.4358 17.9444ZM19.5521 22.0128C19.8042 22.0427 19.9923 22.2813 19.9625 22.5334L19.9257 22.8438C19.8936 23.1153 19.6573 23.284 19.4051 23.2542L11.9959 22.3772L12.5135 22.9892C12.6845 23.2061 12.6501 23.497 12.4332 23.668L12.2163 23.839C11.9993 24.01 11.7084 23.9756 11.5568 23.761L10.1352 21.98C9.91059 21.7174 9.95879 21.3101 10.2385 21.1072L12.0366 19.7073C12.2341 19.534 12.525 19.5684 12.696 19.7853L12.867 20.0022C13.0381 20.2191 13.0036 20.5101 12.7867 20.6811L12.1428 21.1359L19.5521 22.0128Z",
    fill: "#CFD4D9"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1368_1937"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "34",
    height: "34",
    rx: "17",
    fill: "white"
  }))));
};

var CopyAddress = function CopyAddress() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "35",
    height: "35",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "34",
    height: "34",
    rx: "17",
    fill: "#2C2E33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8613 13.2827C12.8165 13.4478 12.7924 13.6214 12.7918 13.8005L12.7884 14.7825L10.9409 14.7762C10.6648 14.7752 10.4401 14.9983 10.4392 15.2745L10.405 25.2744C10.4041 25.5505 10.6272 25.7752 10.9033 25.7761L14.4813 25.7883C14.5694 25.8005 14.6593 25.807 14.7508 25.8073L19.8355 25.8246C19.6043 26.6773 18.8236 27.3032 17.8982 27.3L10.8982 27.2761C9.79363 27.2723 8.90126 26.3738 8.90504 25.2693L8.93921 15.2693C8.94299 14.1648 9.84147 13.2724 10.946 13.2762L12.8613 13.2827Z",
    fill: "#CFD4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0137 9.50214C25.8262 9.50094 26.5147 10.1874 26.5159 10.9999L26.5321 21.9999C26.5333 22.8437 25.8468 23.5009 25.0343 23.5021L16.0343 23.5154C15.1905 23.5166 14.5333 22.8613 14.5321 22.0176L14.5159 11.0176C14.5147 10.2051 15.1699 9.51661 16.0137 9.51537L18.5137 9.51169C18.5121 8.41795 19.3857 7.51041 20.5107 7.50876C21.6045 7.50715 22.5121 8.41206 22.5137 9.50581L25.0137 9.50214ZM20.5126 8.75875C20.0751 8.7594 19.7631 9.10361 19.7637 9.50986C19.7643 9.94736 20.0773 10.2594 20.5148 10.2588C20.921 10.2582 21.2643 9.94515 21.2637 9.50765C21.2631 9.1014 20.9188 8.75816 20.5126 8.75875ZM25.0318 21.8146L25.0162 11.1896C25.016 11.0959 24.9221 11.0023 24.8284 11.0024L23.5159 11.0043L23.5175 12.1293C23.5179 12.3481 23.3306 12.5046 23.1431 12.5049L17.8931 12.5126C17.6743 12.5129 17.5179 12.3569 17.5175 12.1382L17.5159 11.0132L16.2034 11.0151C16.0784 11.0153 16.016 11.1091 16.0162 11.2029L16.0318 21.8279C16.032 21.9529 16.0946 22.0153 16.2196 22.0151L24.8446 22.0024C24.9383 22.0023 25.032 21.9396 25.0318 21.8146Z",
    fill: "#CFD4D9"
  }));
};

var DisconnectWallet = function DisconnectWallet() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "35",
    height: "35",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "34",
    height: "34",
    rx: "17",
    fill: "#2C2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.5H16.125C16.3125 11.5 16.5 11.6875 16.5 11.875V12.625C16.5 12.8438 16.3125 13 16.125 13H13.5C12.6562 13 12 13.6875 12 14.5V20.5C12 21.3438 12.6562 22 13.5 22H16.125C16.3125 22 16.5 22.1875 16.5 22.375V23.125C16.5 23.3438 16.3125 23.5 16.125 23.5H13.5C11.8438 23.5 10.5 22.1562 10.5 20.5V14.5C10.5 12.8438 11.8438 11.5 13.5 11.5ZM20.7188 12.125C20.8438 11.9688 21.0938 11.9688 21.25 12.125L26.375 17.25C26.5312 17.4062 26.5312 17.625 26.375 17.7812L21.25 22.9062C21.0938 23.0625 20.8438 23.0625 20.7188 22.9062L20.0938 22.2812C19.9375 22.1562 19.9375 21.9062 20.0938 21.75L23.625 18.3125H15.875C15.6562 18.3125 15.5 18.1562 15.5 17.9375V17.0625C15.5 16.875 15.6562 16.6875 15.875 16.6875H23.625L20.0938 13.2812C19.9375 13.125 19.9375 12.875 20.0938 12.75L20.7188 12.125Z",
    fill: "#CFD4D9"
  }));
};

var ExclamationSolid = function ExclamationSolid() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90847 3.71849C10.826 2.08733 13.1745 2.08733 14.092 3.71849L20.7884 15.6231C21.6883 17.223 20.5322 19.1998 18.6966 19.1998H5.30388C3.4683 19.1998 2.31219 17.223 3.2121 15.6231L9.90847 3.71849ZM13.2001 15.5999C13.2001 16.2626 12.6629 16.7999 12.0001 16.7999C11.3374 16.7999 10.8001 16.2626 10.8001 15.5999C10.8001 14.9372 11.3374 14.3999 12.0001 14.3999C12.6629 14.3999 13.2001 14.9372 13.2001 15.5999ZM12.0001 5.9999C11.3374 5.9999 10.8001 6.53716 10.8001 7.1999V10.7999C10.8001 11.4626 11.3374 11.9999 12.0001 11.9999C12.6629 11.9999 13.2001 11.4626 13.2001 10.7999V7.1999C13.2001 6.53716 12.6629 5.9999 12.0001 5.9999Z",
    fill: "#E75F59"
  }));
};

var MagicLink = function MagicLink() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "63",
    height: "24",
    viewBox: "0 0 63 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2599 15.6697H36.2201V6.52515H33.4786L31.258 12.2285L29.0374 6.52515H26.3096V15.6697H28.256V9.08893L30.833 15.6697H31.6829L34.2599 9.08893V15.6697Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9699 15.6697H43.7107V11.3922C43.7107 9.48653 42.3263 8.8833 40.8185 8.8833C39.7767 8.8833 38.7349 9.21233 37.9262 9.9252L38.5842 11.0906C39.1462 10.5696 39.8041 10.3091 40.5169 10.3091C41.3942 10.3091 41.9699 10.7478 41.9699 11.4197V12.3382C41.5313 11.8035 40.75 11.5293 39.8727 11.5293C38.8172 11.5293 37.5698 12.0914 37.5698 13.6406C37.5698 15.1213 38.8172 15.8342 39.8727 15.8342C40.7362 15.8342 41.5176 15.5189 41.9699 14.9842V15.6697ZM41.9699 14.0794C41.6821 14.4632 41.1338 14.6551 40.5718 14.6551C39.8864 14.6551 39.3244 14.2987 39.3244 13.6817C39.3244 13.0511 39.8864 12.6809 40.5718 12.6809C41.1338 12.6809 41.6821 12.8728 41.9699 13.2568V14.0794Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3001 17.3697C46.1225 18.0964 47.0135 18.3568 48.1513 18.3568C49.7824 18.3568 51.7289 17.7399 51.7289 15.2173V9.04778H49.9744V9.89783C49.4398 9.22605 48.727 8.8833 47.9319 8.8833C46.2596 8.8833 45.0122 10.0898 45.0122 12.2559C45.0122 14.4632 46.2733 15.6286 47.9319 15.6286C48.7407 15.6286 49.4535 15.2446 49.9744 14.5866V15.2584C49.9744 16.5608 48.9874 16.931 48.1513 16.931C47.3151 16.931 46.616 16.6979 46.0814 16.1084L45.3001 17.3697ZM49.9744 13.3253C49.6865 13.7503 49.0559 14.0794 48.4802 14.0794C47.4933 14.0794 46.8079 13.3939 46.8079 12.2559C46.8079 11.118 47.4933 10.4325 48.4802 10.4325C49.0559 10.4325 49.6865 10.7478 49.9744 11.1865V13.3253Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3191 8.07443C54.8949 8.07443 55.3609 7.60823 55.3609 7.03244C55.3609 6.45662 54.8949 5.99048 54.3191 5.99048C53.7571 5.99048 53.2773 6.45662 53.2773 7.03244C53.2773 7.60823 53.7571 8.07443 54.3191 8.07443ZM53.4555 15.6697H55.1964V9.04778H53.4555V15.6697Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4976 12.3519C56.4976 14.3947 57.9643 15.8342 60.0067 15.8342C61.3637 15.8342 62.1862 15.2447 62.6248 14.6278L61.4871 13.5721C61.1719 14.0108 60.6921 14.285 60.0889 14.285C59.0335 14.285 58.2933 13.5035 58.2933 12.3519C58.2933 11.2003 59.0335 10.4325 60.0889 10.4325C60.6921 10.4325 61.1719 10.693 61.4871 11.1455L62.6248 10.0898C62.1862 9.4728 61.3637 8.8833 60.0067 8.8833C57.9643 8.8833 56.4976 10.3229 56.4976 12.3519Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90013 0C10.8942 1.21772 11.9906 2.34857 13.1762 3.37944C12.3863 5.94206 11.9611 8.66468 11.9611 11.4866C11.9611 14.3085 12.3863 17.0312 13.1763 19.5938C11.9907 20.6246 10.8943 21.7555 9.9002 22.9732C8.90623 21.7556 7.80997 20.6248 6.62451 19.5941C7.41451 17.0314 7.83982 14.3087 7.83982 11.4866C7.83982 8.66453 7.41451 5.94178 6.6245 3.37903C7.80995 2.34827 8.90623 1.21755 9.90013 0ZM4.358 17.822C3.10326 16.9424 1.77163 16.165 0.375211 15.502C0.762605 14.232 0.971004 12.8838 0.971004 11.487C0.971004 10.0899 0.762529 8.74148 0.375 7.4712C1.7715 6.80815 3.10319 6.03076 4.358 5.15113C4.83784 7.18499 5.09174 9.30615 5.09174 11.4866C5.09174 13.667 4.83784 15.7882 4.358 17.822ZM14.7085 11.4866C14.7085 13.667 14.9624 15.7882 15.4423 17.8221C16.6972 16.9424 18.0291 16.1648 19.4258 15.5018C19.0385 14.2318 18.8302 12.8837 18.8302 11.4869C18.8302 10.0901 19.0386 8.74178 19.426 7.4716C18.0292 6.80846 16.6973 6.03093 15.4423 5.15113C14.9624 7.18499 14.7085 9.30615 14.7085 11.4866Z",
    fill: "#F8F9FA"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "62.25",
    height: "23.25",
    fill: "white",
    transform: "translate(0.375)"
  }))));
};

var SolanaWallet = function SolanaWallet(_a) {
  var wallet = _a.wallet,
    props = __rest(_a, ["wallet"]);
  return wallet && /*#__PURE__*/React.createElement("img", _extends({
    height: 25,
    width: 25,
    src: wallet.adapter.icon,
    alt: "".concat(wallet.adapter.name, " icon")
  }, props));
};

var Open = function Open() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "35",
    height: "35",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "17.5",
    fill: "#2C2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2845 9.00029C26.2586 9.00111 26.2327 9.00338 26.2071 9.00708H22.1259C21.8751 9.00354 21.6418 9.1353 21.5154 9.3519C21.389 9.5685 21.389 9.8364 21.5154 10.053C21.6418 10.2696 21.8751 10.4014 22.1259 10.3978H24.6194L17.462 17.5552C17.2804 17.7296 17.2072 17.9886 17.2707 18.2323C17.3342 18.476 17.5245 18.6663 17.7682 18.7298C18.0119 18.7933 18.2709 18.7202 18.4453 18.5385L25.6027 11.3811V13.8746C25.5992 14.1254 25.7309 14.3587 25.9475 14.4851C26.1641 14.6115 26.432 14.6115 26.6486 14.4851C26.8652 14.3587 26.997 14.1254 26.9934 13.8746V9.79072C27.0215 9.58808 26.9589 9.38338 26.8223 9.2311C26.6857 9.07881 26.489 8.99438 26.2845 9.00029ZM12.3907 11.7886C11.6307 11.7886 11 12.4192 11 13.1793V23.6098C11 24.3699 11.6307 25.0005 12.3907 25.0005H22.8212C23.5813 25.0005 24.212 24.3699 24.212 23.6098V16.6561V14.8634L22.8212 16.2541V18.0469V23.6098H12.3907V13.1793H17.9537H19.3444H19.7464L21.1372 11.7886H19.3444H17.9537L12.3907 11.7886Z",
    fill: "#CFD4D9"
  }));
};

var Secure = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.5rem",
  color: "hsl(210, 17%, 98%)",
  fontSize: "12px",
  opacity: "0.6",
  position: "absolute",
  right: 0,
  left: 0,
  bottom: "-2rem",
  "@media (max-width: 640px)": {
    top: "-2rem",
    bottom: "unset"
  }
});
var MagicLinkSecure = function MagicLinkSecure() {
  return /*#__PURE__*/React.createElement(Secure, null, "secured by", /*#__PURE__*/React.createElement(MagicLink, null));
};

var Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  color: "hsl(210, 17%, 98%)",
  gap: "1.375rem"
});
var Title = styled("div")({
  fontFamily: "Inter",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "1.375rem",
  width: "100%",
  fontSize: "1.25rem",
  color: "hsl(210, 17%, 98%)"
});
var ActionsWrapper = styled("div")({
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  alignItems: "start",
  justifyItems: "center",
  width: "100%",
  ".start": {
    justifySelf: "start"
  },
  ".end": {
    justifySelf: "end"
  }
});
var Actions = function Actions(_ref) {
  var children = _ref.children;
  var count = Children.count(children);
  return /*#__PURE__*/React.createElement(ActionsWrapper, null, count === 2 && /*#__PURE__*/React.createElement("span", null), children);
};
var DialogHeader = function DialogHeader(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(Container, null, children);
};
DialogHeader.Title = Title;
DialogHeader.Actions = Actions;

var DialogContent = styled(DialogActions)({
  display: "flex",
  flexDirection: "column",
  gap: "0.375rem",
  padding: 0,
  "& > :not(:first-of-type)": {
    margin: 0
  }
});

var DialogActionButton = styled("button")({
  background: "#2C2E33",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  width: "32px",
  height: "32px",
  borderRadius: "999px",
  paddding: "0.25rem",
  color: "#CFD4D9",
  "&:hover": {
    background: "#36393e"
  }
});
var IconWrapper = styled("div")({
  background: "hsl(225, 7%, 11%)",
  paddding: "0.125rem",
  color: "hsl(210, 17%, 98%)",
  width: "48px",
  height: "48px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  "> .MuiSvgIcon-root, > svg": {
    height: "1.6rem",
    width: "1.6rem"
  }
});
var DialogIconWrapper = function DialogIconWrapper(_ref) {
  var Icon = _ref.Icon,
    style = _ref.style;
  return /*#__PURE__*/React.createElement(IconWrapper, {
    style: style
  }, /*#__PURE__*/React.createElement(Icon, null));
};
var DialogLogoWrapper = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "999px",
  height: "4.5rem",
  width: "4.5rem",
  overflow: "hidden",
  backgroundColor: "rgba(54, 111, 188, 0.20)"
});

var img$1 = "data:image/png;base64,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";

var Centered = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
var LogoCircle = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  height: "fit-content",
  width: "fit-content",
  "& > img": {
    "@keyframes rotate": {
      to: {
        transform: "rotate(0deg)"
      },
      from: {
        transform: "rotate(360deg)"
      }
    },
    animation: "rotate 1.5s infinite linear"
  }
});
function LoadingSpinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/React.createElement(Centered, null, /*#__PURE__*/React.createElement(LogoCircle, null, /*#__PURE__*/React.createElement("img", {
    alt: "loading-spinner",
    src: img$1,
    width: size,
    height: size
  })));
}

var DialogWrapper = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  height: "100%",
  width: "100%",
  flex: 1,
  gap: "1.45rem",
  color: "hsl(210, 17%, 98%)"
});
var LoadingDialog = function LoadingDialog() {
  return /*#__PURE__*/React.createElement(DialogWrapper, null, /*#__PURE__*/React.createElement(LoadingSpinner, {
    size: 40
  }), /*#__PURE__*/React.createElement(Typography, null, "submitting..."));
};

var ErrorMessage = styled("div")({
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  width: "100%",
  gap: "0.5rem",
  color: "hsl(3, 75%, 63%)",
  "& > .MuiTypography-root": {
    fontSize: "1rem",
    lineHeight: "unset"
  }
});
var DialogErrorMessage = function DialogErrorMessage(_ref) {
  var Icon = _ref.Icon,
    message = _ref.message;
  return /*#__PURE__*/React.createElement(ErrorMessage, null, /*#__PURE__*/React.createElement(Icon, null), " ", /*#__PURE__*/React.createElement(Typography, null, message));
};

var CustomDialog = styled(Dialog$1)({
  "& .MuiBackdrop-root": {
    backdropFilter: "blur(5px)",
    background: "hsl(220, 9%, 7%)"
  },
  "& .MuiDialog-container": {
    alignItems: "center"
  },
  "& .MuiDialog-paper": {
    background: "hsl(225, 7%, 11%)",
    minWidth: "16rem",
    padding: "1.375rem",
    gap: "1.375rem",
    borderRadius: "1.3125rem",
    minHeight: "var(--dialog-paper-height, auto)",
    transition: "min-height 0.4s ease-in-out",
    boxSizing: "content-box",
    overflowY: "unset"
  },
  "& .MuiDialogContent-root": {
    padding: 0,
    "& .MuiCollapse-root": {
      "& .MuiList-root": {
        background: "hsl(230, 8%, 16%)"
      }
    },
    "& .MuiList-root": {
      padding: 0
    }
  },
  "@media (max-width: 640px)": {
    "& .MuiDialog-container": {
      alignItems: "flex-end"
    },
    "& .MuiDialog-paper": {
      width: "100%",
      margin: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  }
});
var Transition = /*#__PURE__*/forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/React.createElement(Slide, _extends({
    direction: "up",
    ref: ref
  }, props));
});
var Dialog = function Dialog(_a) {
  var transitionProps = _a.transitionProps,
    props = __rest(_a, ["transitionProps"]);
  return /*#__PURE__*/React.createElement(CustomDialog, _extends({}, props, {
    TransitionComponent: Transition,
    TransitionProps: Object.assign({
      timeout: 500
    }, transitionProps)
  }), props.children);
};

var LogInButton = styled("button")({
  display: "grid",
  gridTemplateColumns: "repeat(3, auto)",
  background: "#25262B",
  fontFamily: "Space Grotesk",
  borderRadius: "0.75rem",
  padding: "0.5rem",
  fontWeight: "500",
  alignItems: "center",
  justifyItems: "start",
  width: "100%",
  margin: "0 !important",
  color: "#F8F9FA",
  textDecoration: "capitalize",
  border: "none",
  "&:hover": {
    background: "hsl(223, 6%, 23%)",
    svg: {
      opacity: 0.8
    }
  }
});
var ArrowFowardIcon = styled(ArrowFoward)({
  color: "#F8F9FA",
  opacity: 0.2
});
var LogInContent = function LogInContent(_ref) {
  var handleWalletLogIn = _ref.handleWalletLogIn,
    handleMagicLinkLogIn = _ref.handleMagicLinkLogIn,
    _ref$disableMagicLink = _ref.disableMagicLink,
    disableMagicLink = _ref$disableMagicLink === void 0 ? false : _ref$disableMagicLink;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React$1.createElement(DialogContent, null, !disableMagicLink && /*#__PURE__*/React$1.createElement(LogInButton, {
    onClick: handleMagicLinkLogIn
  }, /*#__PURE__*/React$1.createElement(DialogIconWrapper, {
    Icon: MailOutline
  }), /*#__PURE__*/React$1.createElement(Typography, null, t("connectWallet.login.email")), /*#__PURE__*/React$1.createElement(ArrowFowardIcon, null)), /*#__PURE__*/React$1.createElement(LogInButton, {
    onClick: handleWalletLogIn
  }, /*#__PURE__*/React$1.createElement(DialogIconWrapper, {
    Icon: WalletOutline
  }), /*#__PURE__*/React$1.createElement(Typography, null, t("connectWallet.login.wallet")), /*#__PURE__*/React$1.createElement(ArrowFowardIcon, null)));
};

var img = "data:image/png;base64,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";

var LogoWrapper = styled(DialogLogoWrapper)({
  alignItems: "flex-end",
  height: "72px",
  width: "72px",
  backgroundColor: "hsl(225, 3%, 76%)",
  "> img.dewi-logo": {
    filter: "grayscale(80%)",
    alignSelf: "end"
  }
});
var LogInHeader = function LogInHeader(_ref) {
  var handleClose = _ref.handleClose,
    Logo = _ref.Logo,
    connectLabel = _ref.connectLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(DialogHeader, null, /*#__PURE__*/React.createElement(DialogHeader.Actions, null, /*#__PURE__*/React.createElement(LogoWrapper, null, Logo ? /*#__PURE__*/React.createElement(Logo, null) : /*#__PURE__*/React.createElement("img", {
    className: "dewi-logo",
    alt: "dewi-logo",
    src: img,
    height: 60,
    width: 60
  })), /*#__PURE__*/React.createElement(DialogActionButton, {
    className: "end",
    onClick: handleClose,
    "aria-label": "close"
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(DialogHeader.Title, null, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      textAlign: "center"
    }
  }, connectLabel || t("connectWallet.login.title"))));
};

var WalletButton = styled("button")({
  display: "flex",
  background: "transparent",
  gap: "1rem",
  justifyContent: "flex-start",
  padding: "0.5rem",
  border: "1px solid hsl(210, 8%, 31%)",
  color: "hsl(210, 17%, 98%)",
  flexGrow: 1,
  margin: "0.25rem 0",
  borderRadius: "0.5rem",
  fontSize: "1.125rem",
  fontWeight: 400
});
var WalletText = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  color: "hsl(210, 17%, 98%)"
});
var ButtonListItem = styled(ListItem)({
  padding: "0"
});
var WalletListItem = function WalletListItem(_a) {
  var onClick = _a.onClick,
    wallet = _a.wallet,
    props = __rest(_a, ["onClick", "wallet"]);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var walletText = wallet.adapter.connected ? t("connectWallet.wallets.connected") : t("connectWallet.wallets.detected");
  var notDetected = useMemo(function () {
    return wallet.readyState === WalletReadyState.NotDetected || wallet.readyState === WalletReadyState.Loadable;
  }, [wallet.readyState]);
  return /*#__PURE__*/React.createElement(ButtonListItem, props, /*#__PURE__*/React.createElement(WalletButton, {
    disabled: walletText === t("connectWallet.wallets.connected") || notDetected,
    onClick: onClick,
    sx: {
      opacity: notDetected ? 0.75 : 1,
      "&:hover": notDetected ? {} : {
        background: "hsl(210, 9%, 23%)"
      }
    }
  }, /*#__PURE__*/React.createElement(SolanaWallet, {
    wallet: wallet
  }), /*#__PURE__*/React.createElement(WalletText, null, /*#__PURE__*/React.createElement(Typography, {
    fontSize: "1rem"
  }, wallet.adapter.name), wallet.readyState === WalletReadyState.Installed && /*#__PURE__*/React.createElement(Typography, {
    fontSize: "0.75rem"
  }, walletText), notDetected && /*#__PURE__*/React.createElement(Typography, {
    fontSize: "0.75rem"
  }, t("connectWallet.wallets.notDetected")))));
};

var WalletsContent = function WalletsContent(_ref) {
  var _ref$featuredWallets = _ref.featuredWallets,
    featuredWallets = _ref$featuredWallets === void 0 ? 3 : _ref$featuredWallets,
    handleClose = _ref.handleClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSolana = useSolana(),
    wallets = _useSolana.wallets,
    select = _useSolana.select;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useMemo = useMemo(function () {
      var installed = [];
      var loadable = [];
      var notDetected = [];
      var _iterator = _createForOfIteratorHelper(wallets),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var wallet = _step.value;
          if (wallet.readyState === WalletReadyState.NotDetected) {
            notDetected.push(wallet);
          } else if (wallet.readyState === WalletReadyState.Loadable) {
            loadable.push(wallet);
          } else if (wallet.readyState === WalletReadyState.Installed) {
            installed.push(wallet);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var orderedWallets = [].concat(installed, loadable, notDetected);
      return [orderedWallets.slice(0, featuredWallets), orderedWallets.slice(featuredWallets)];
    }, [wallets, featuredWallets]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    featured = _useMemo2[0],
    more = _useMemo2[1];
  var handleWalletClick = useCallback(function (_, walletName) {
    select(walletName);
    handleClose();
  }, [select, handleClose]);
  var handleExpandClick = useCallback(function () {
    return setExpanded(!expanded);
  }, [setExpanded, expanded]);
  return /*#__PURE__*/React$1.createElement(DialogContent, null, /*#__PURE__*/React$1.createElement(List, {
    sx: {
      width: "100%"
    }
  }, featured.map(function (wallet) {
    return /*#__PURE__*/React$1.createElement(WalletListItem, {
      key: wallet.adapter.name,
      onClick: function onClick(event) {
        return handleWalletClick(event, wallet.adapter.name);
      },
      wallet: wallet
    });
  }), more.length ? /*#__PURE__*/React$1.createElement(Collapse, {
    "in": expanded,
    timeout: "auto",
    unmountOnExit: true
  }, more.map(function (wallet) {
    return /*#__PURE__*/React$1.createElement(WalletListItem, {
      key: wallet.adapter.name,
      onClick: function onClick(event) {
        return handleWalletClick(event, wallet.adapter.name);
      },
      wallet: wallet
    });
  })) : null), more.length ? /*#__PURE__*/React$1.createElement(ListItem, {
    sx: {
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React$1.createElement(Button$1, {
    size: "medium",
    onClick: handleExpandClick
  }, expanded ? t("connectWallet.wallets.lessOptions") : t("connectWallet.wallets.moreOptions"), expanded ? /*#__PURE__*/React$1.createElement(ArrowDropUp, null) : /*#__PURE__*/React$1.createElement(ArrowDropDown, null))) : null);
};

var WalletsHeader = function WalletsHeader(_ref) {
  var handleClose = _ref.handleClose,
    onBack = _ref.onBack;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(DialogHeader, null, /*#__PURE__*/React.createElement(DialogHeader.Actions, null, /*#__PURE__*/React.createElement(DialogActionButton, {
    className: "start",
    onClick: onBack
  }, /*#__PURE__*/React.createElement(ArrowBack, null)), /*#__PURE__*/React.createElement(DialogLogoWrapper, null, /*#__PURE__*/React.createElement(WalletOutline, {
    size: 30,
    color: "#66A9F1"
  })), /*#__PURE__*/React.createElement(DialogActionButton, {
    className: "end",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(DialogHeader.Title, null, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      maxWidth: "15.125rem"
    }
  }, t("connectWallet.wallets.title"))));
};

var EmailField = styled(TextField)(function (_ref) {
  var error = _ref.error;
  return {
    width: "100%",
    "& .MuiInputBase-root": {
      background: "hsl(230, 8%, 16%)",
      borderRadius: "0.75rem",
      fontSize: "1rem",
      color: "#F8F9FA",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: error ? "#E75F59" : "#353A3F"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid hsl(210, 9%, 23%)"
    }
  };
});
var CustomConnectButton = styled(Button$1)({
  backgroundColor: "white !important",
  "&:disabled": {
    backgroundColor: "hsl(214, 9%, 15%) !important",
    color: "white"
  },
  "&:hover": {
    backgroundColor: "hsl(210, 6%, 56%) !important"
  },
  color: "hsl(220, 9%, 7%) !important",
  textTransform: "none",
  borderRadius: "31.26rem",
  fontSize: "1rem",
  fontWeight: "700",
  lineHeight: "1.25rem",
  height: "2.75rem",
  marginTop: "1.25rem",
  width: "100%"
});
var EmailContent = function EmailContent() {
  var _useSolana = useSolana(),
    login = _useSolana.login,
    magicAuthenticationStatus = _useSolana.magicAuthenticationStatus;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isEmailValid = _useState4[0],
    setIsEmailValid = _useState4[1];
  var handleMagicLogIn = useCallback(function () {
    if (!email) return;
    login({
      email: email,
      showUI: false
    });
  }, [login, email]);
  var validateEmailFormat = useCallback(function (newEmail) {
    var emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return emailRegex.test(newEmail);
  }, []);
  var handleEmailChange = useCallback(function (event) {
    var newEmail = event.target.value;
    setEmail(newEmail);
    if (!isEmailValid) {
      setIsEmailValid(validateEmailFormat(newEmail));
    }
  }, [isEmailValid, validateEmailFormat]);
  var handleEmailBlur = useCallback(function () {
    if (!email) return;
    setIsEmailValid(validateEmailFormat(email));
  }, [email, validateEmailFormat]);
  var handleKeyPress = useCallback(function (event) {
    if (event.key === "Enter") {
      if (!email) return;
      if (!validateEmailFormat(email)) {
        setIsEmailValid(false);
        return;
      }
      handleMagicLogIn();
    }
  }, [email, handleMagicLogIn, validateEmailFormat]);
  return /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(EmailField, {
    onChange: handleEmailChange,
    onBlur: handleEmailBlur,
    type: "email",
    name: "email",
    autoComplete: "email",
    placeholder: "Email",
    value: email,
    error: !isEmailValid,
    onKeyDown: handleKeyPress
  }), (!isEmailValid || magicAuthenticationStatus === "errored") && /*#__PURE__*/React.createElement(DialogErrorMessage, {
    Icon: ExclamationSolid,
    message: t("connectWallet.email.error")
  }), /*#__PURE__*/React.createElement(CustomConnectButton, {
    onClick: handleMagicLogIn,
    disabled: !isEmailValid
  }, t("connectWallet.email.submit")));
};

var EmailHeader = function EmailHeader(_ref) {
  var handleClose = _ref.handleClose,
    onBack = _ref.onBack;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(DialogHeader, null, /*#__PURE__*/React.createElement(DialogHeader.Actions, null, /*#__PURE__*/React.createElement(DialogActionButton, {
    className: "start",
    onClick: onBack
  }, /*#__PURE__*/React.createElement(ArrowBack, null)), /*#__PURE__*/React.createElement(DialogLogoWrapper, null, /*#__PURE__*/React.createElement(MailOutline, {
    size: 40
  })), /*#__PURE__*/React.createElement(DialogActionButton, {
    className: "end",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(DialogHeader.Title, null, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      maxWidth: "15.125rem"
    }
  }, t("connectWallet.email.title"))));
};

var ConnectedContent = function ConnectedContent(_ref) {
  var changeWallet = _ref.changeWallet,
    handleClose = _ref.handleClose,
    disconnect = _ref.disconnect,
    _ref$publicAddress = _ref.publicAddress,
    publicAddress = _ref$publicAddress === void 0 ? "" : _ref$publicAddress,
    _ref$magicLogin = _ref.magicLogin,
    magicLogin = _ref$magicLogin === void 0 ? false : _ref$magicLogin;
  var _a, _b, _c;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useWallet = useWallet(),
    wallet = _useWallet.wallet;
  var handleCopyAddress = function handleCopyAddress() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return navigator.clipboard.writeText(publicAddress);
          case 2:
            handleClose();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  var handleDisconnect = function handleDisconnect() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return disconnect();
          case 2:
            handleClose();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  };
  var openTiplinkWallet = useCallback(function () {
    window.open("https://tiplink.io/", "_blank");
  }, []);
  return /*#__PURE__*/React.createElement(DialogContent, {
    id: "wallet-menu",
    sx: {
      gap: "0.5rem"
    }
  }, ((_c = (_b = (_a = wallet === null || wallet === void 0 ? void 0 : wallet.adapter) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes("tiplink")) && /*#__PURE__*/React.createElement(ConnectedListItem, {
    onClick: openTiplinkWallet,
    Icon: Open,
    text: t("connectWallet.connected.openWallet")
  }), /*#__PURE__*/React.createElement(ConnectedListItem, {
    onClick: handleCopyAddress,
    Icon: CopyAddress,
    text: t("connectWallet.connected.copyAddress")
  }), !magicLogin && /*#__PURE__*/React.createElement(ConnectedListItem, {
    onClick: changeWallet,
    Icon: ChangeWallet,
    text: t("connectWallet.connected.changeWallet")
  }), /*#__PURE__*/React.createElement(ConnectedListItem, {
    onClick: handleDisconnect,
    Icon: DisconnectWallet,
    text: t("connectWallet.connected.disconnect")
  }));
};
var ListItemButton = styled("button")({
  display: "flex",
  background: "transparent",
  gap: "1rem",
  justifyContent: "flex-start",
  padding: "0.5rem",
  width: "100%",
  margin: 0,
  border: "1px solid #2C2E33",
  alignItems: "center",
  color: "#F8F9FA",
  borderRadius: "0.75rem",
  fontSize: "1.125rem",
  fontWeight: 400,
  "&:hover": {
    background: "#26272c"
  }
});
var ConnectedListItem = function ConnectedListItem(_ref2) {
  var onClick = _ref2.onClick,
    Icon = _ref2.Icon,
    text = _ref2.text;
  return /*#__PURE__*/React.createElement(ListItemButton, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, null), /*#__PURE__*/React.createElement(Typography, {
    fontSize: "1rem"
  }, text));
};

var getPublicAddress = function getPublicAddress(publicAddress) {
  if (!publicAddress) return undefined;
  return "".concat(publicAddress.slice(0, 4), "..").concat(publicAddress.slice(-4));
};

var JazzIcon = function JazzIcon(_ref) {
  var diameter = _ref.diameter,
    className = _ref.className,
    publicAddress = _ref.publicAddress;
  var ref = useRef(null);
  useEffect(function () {
    var icon = jazzicon(diameter, publicAddress);
    if (ref.current) {
      ref.current.innerHTML = "";
      ref.current.appendChild(icon);
    }
  }, [diameter]);
  return /*#__PURE__*/React$1.createElement("div", {
    className: className,
    ref: ref
  });
};

var ConnectedHeader = function ConnectedHeader(_ref) {
  var handleClose = _ref.handleClose,
    _ref$publicAddress = _ref.publicAddress,
    publicAddress = _ref$publicAddress === void 0 ? "" : _ref$publicAddress;
  return /*#__PURE__*/React.createElement(DialogHeader, null, /*#__PURE__*/React.createElement(DialogHeader.Actions, null, /*#__PURE__*/React.createElement(JazzIcon, {
    className: "center",
    publicAddress: publicAddress,
    diameter: 70
  }), /*#__PURE__*/React.createElement(DialogActionButton, {
    className: "end",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(DialogHeader.Title, null, /*#__PURE__*/React.createElement(Typography, null, getPublicAddress(publicAddress))));
};

var Input = styled(MuiOtpInput)(function (_ref) {
  var error = _ref.error;
  return {
    gap: "0.25rem",
    "& .MuiOtpInput-TextField-3": {
      marginRight: "1.25rem"
    },
    "& .MuiInputBase-root": {
      margin: 0,
      color: "#f9fafb",
      background: "#25262B",
      borderRadius: "0.75rem",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: error ? "#E75F59" : "#353A3F",
      width: "2.75rem",
      height: "2.75rem",
      textAlign: "center"
    }
  };
});
var PinInput = function PinInput(_ref2) {
  var onComplete = _ref2.onComplete,
    _ref2$error = _ref2.error,
    error = _ref2$error === void 0 ? false : _ref2$error;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var handleChange = function handleChange(newVal) {
    setValue(newVal);
  };
  var handleValidInput = function handleValidInput(character) {
    return /\d/.test(character);
  };
  return /*#__PURE__*/React$1.createElement(Input, {
    validateChar: handleValidInput,
    length: 6,
    value: value,
    onChange: handleChange,
    onComplete: onComplete,
    error: error
  });
};

var AuthenticateCodeContent = function AuthenticateCodeContent(_ref) {
  var error = _ref.error;
  var _useSolana = useSolana(),
    handleLoginCode = _useSolana.handleLoginCode;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleOnResult = useCallback(function (value) {
    handleLoginCode(value);
  }, [handleLoginCode]);
  return /*#__PURE__*/React$1.createElement(DialogContent, null, /*#__PURE__*/React$1.createElement(PinInput, {
    onComplete: handleOnResult,
    error: error
  }), error && /*#__PURE__*/React$1.createElement(DialogErrorMessage, {
    Icon: ExclamationSolid,
    message: t("connectWallet.authenticateCode.error")
  }));
};

var AuthenticateCodeHeader = function AuthenticateCodeHeader(_ref) {
  var handleClose = _ref.handleClose,
    onBack = _ref.onBack;
  var _useSolana = useSolana(),
    metadata = _useSolana.metadata;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleCloseButton = useCallback(function () {
    handleClose();
  }, [handleClose]);
  return /*#__PURE__*/React.createElement(DialogHeader, null, /*#__PURE__*/React.createElement(DialogHeader.Actions, null, /*#__PURE__*/React.createElement(DialogActionButton, {
    onClick: onBack
  }, /*#__PURE__*/React.createElement(ArrowBack, null)), /*#__PURE__*/React.createElement(DialogLogoWrapper, {
    className: "center"
  }, /*#__PURE__*/React.createElement(Sparkle, {
    size: 42,
    color: "hsl(214, 61%, 53%"
  })), /*#__PURE__*/React.createElement(DialogActionButton, {
    className: "end",
    onClick: handleCloseButton
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(DialogHeader.Title, null, /*#__PURE__*/React.createElement(Typography, {
    fontSize: 19
  }, t("connectWallet.authenticateCode.title")), /*#__PURE__*/React.createElement(Typography, {
    fontSize: 19,
    fontWeight: 700
  }, !!metadata && (metadata === null || metadata === void 0 ? void 0 : metadata.email))));
};

var ConnectDialog = function ConnectDialog(_a) {
  var handleClose = _a.handleClose,
    disableMagicLink = _a.disableMagicLink,
    logo = _a.logo,
    connectLabel = _a.connectLabel,
    rest = __rest(_a, ["handleClose", "disableMagicLink", "logo", "connectLabel"]);
  var _useSolana = useSolana(),
    connected = _useSolana.connected,
    connecting = _useSolana.connecting,
    publicKey = _useSolana.publicKey,
    wallet = _useSolana.wallet,
    _disconnect = _useSolana.disconnect,
    magicAuthenticationStatus = _useSolana.magicAuthenticationStatus,
    cancel = _useSolana.cancel,
    restartSession = _useSolana.restartSession;
  var _useContext = useContext(ConnectWalletContext),
    walletDialogState = _useContext.walletDialogState,
    updateWalletDialogState = _useContext.updateWalletDialogState;
  useEffect(function () {
    if (!connected) {
      updateWalletDialogState("logIn");
    }
  }, [connected]);
  useEffect(function () {
    if (magicAuthenticationStatus === "authenticated") {
      handleClose();
      updateWalletDialogState("connected");
    }
    if (walletDialogState !== "authenticationCode" && (magicAuthenticationStatus === "authenticationCode" || magicAuthenticationStatus === "invalid-code" || magicAuthenticationStatus === "pending")) {
      updateWalletDialogState("authenticationCode");
    }
    if (magicAuthenticationStatus === "errored" && walletDialogState === "authenticationCode") {
      updateWalletDialogState("email");
    }
  }, [magicAuthenticationStatus]);
  var restartMagicLinkStatus = useCallback(function () {
    if (magicAuthenticationStatus === "errored") restartSession();
  }, [restartSession, magicAuthenticationStatus]);
  var handleDialogClosed = useCallback(function () {
    var isConnected = !!wallet || !!publicKey;
    if (walletDialogState !== "authenticationCode" || magicAuthenticationStatus === "unauthenticated") {
      restartMagicLinkStatus();
      updateWalletDialogState(isConnected ? "connected" : "logIn");
    }
  }, [walletDialogState, magicAuthenticationStatus, restartMagicLinkStatus, updateWalletDialogState, wallet, publicKey]);
  var getDialogHeader = function getDialogHeader() {
    var headers = {
      logIn: /*#__PURE__*/React.createElement(LogInHeader, {
        handleClose: handleClose,
        Logo: logo,
        connectLabel: connectLabel
      }),
      wallets: /*#__PURE__*/React.createElement(WalletsHeader, {
        handleClose: handleClose,
        onBack: function onBack() {
          updateWalletDialogState(!!wallet || !!publicKey || magicAuthenticationStatus === "authenticated" ? "connected" : "logIn");
        }
      }),
      email: /*#__PURE__*/React.createElement(EmailHeader, {
        handleClose: handleClose,
        onBack: function onBack() {
          return updateWalletDialogState("logIn");
        }
      }),
      authenticationCode: /*#__PURE__*/React.createElement(AuthenticateCodeHeader, {
        handleClose: handleClose,
        onBack: function onBack() {
          updateWalletDialogState("email");
          cancel();
        }
      }),
      connected: /*#__PURE__*/React.createElement(ConnectedHeader, {
        handleClose: handleClose,
        publicAddress: publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58()
      })
    };
    return headers[walletDialogState];
  };
  var getDialogContent = function getDialogContent() {
    var contents = {
      logIn: /*#__PURE__*/React.createElement(LogInContent, {
        handleWalletLogIn: function handleWalletLogIn() {
          return updateWalletDialogState("wallets");
        },
        handleMagicLinkLogIn: function handleMagicLinkLogIn() {
          return updateWalletDialogState("email");
        },
        disableMagicLink: disableMagicLink
      }),
      wallets: /*#__PURE__*/React.createElement(WalletsContent, {
        handleClose: handleClose
      }),
      email: /*#__PURE__*/React.createElement(EmailContent, null),
      authenticationCode: /*#__PURE__*/React.createElement(AuthenticateCodeContent, {
        error: magicAuthenticationStatus === "invalid-code"
      }),
      connected: /*#__PURE__*/React.createElement(ConnectedContent, {
        changeWallet: function changeWallet() {
          return updateWalletDialogState("wallets");
        },
        handleClose: handleClose,
        publicAddress: publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58(),
        disconnect: function disconnect() {
          return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _disconnect();
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
        },
        magicLogin: magicAuthenticationStatus === "authenticated"
      })
    };
    return contents[walletDialogState];
  };
  var dialogHeights = {
    logIn: disableMagicLink ? "12.75rem" : "17.875rem",
    wallets: "14.5rem",
    email: "16.8rem",
    authenticationCode: "15.6rem",
    connected: "14.625rem",
    "default": "8.5rem"
  };
  var stateDialogHeight = connecting ? dialogHeights["default"] : dialogHeights[walletDialogState];
  return /*#__PURE__*/React.createElement(Dialog, _extends({}, rest, {
    onClose: handleClose,
    sx: {
      "& .MuiDialog-paper": {
        "--dialog-paper-height": stateDialogHeight
      }
    },
    transitionProps: {
      onExited: handleDialogClosed
    }
  }), connecting ? /*#__PURE__*/React.createElement(LoadingDialog, null) : /*#__PURE__*/React.createElement(Fragment, null, getDialogHeader(), getDialogContent(), ["authenticationCode", "email"].includes(walletDialogState) && /*#__PURE__*/React.createElement(MagicLinkSecure, null)));
};

var useIsSmallScreen = function useIsSmallScreen(maxWidth) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSmallScreen = _useState2[0],
    setIsSmallScreen = _useState2[1];
  useEffect(function () {
    if (typeof window !== "undefined") {
      var handleResize = function handleResize() {
        setIsSmallScreen(window.innerWidth <= maxWidth);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return function () {
        return window.removeEventListener("resize", handleResize);
      };
    }
    return;
  }, [maxWidth]);
  return isSmallScreen;
};

var ConnectButton = function ConnectButton(_a) {
  var _a$compresedView = _a.compresedView,
    compresedView = _a$compresedView === void 0 ? false : _a$compresedView,
    _a$disableMagicLink = _a.disableMagicLink,
    disableMagicLink = _a$disableMagicLink === void 0 ? false : _a$disableMagicLink,
    logo = _a.logo,
    connectLabel = _a.connectLabel,
    rest = __rest(_a, ["compresedView", "disableMagicLink", "logo", "connectLabel"]);
  var _useSolana = useSolana(),
    publicKey = _useSolana.publicKey,
    wallet = _useSolana.wallet,
    magicAuthenticationStatus = _useSolana.magicAuthenticationStatus,
    restartSession = _useSolana.restartSession;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useContext = useContext(ConnectWalletContext),
    walletDialogState = _useContext.walletDialogState,
    updateWalletDialogState = _useContext.updateWalletDialogState;
  var isSmallScreen = useIsSmallScreen(640);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleClose = useCallback(function () {
    setOpen(false);
  }, []);
  useEffect(function () {
    var isConnected = !!wallet || !!publicKey;
    if (magicAuthenticationStatus === "authenticated") {
      handleClose();
      if (!isConnected || walletDialogState !== "connected") {
        updateWalletDialogState("connected");
      }
    } else if (magicAuthenticationStatus === "errored" && walletDialogState === "authenticationCode") {
      updateWalletDialogState("email");
    } else {
      var isAuthCodeRelated = ["authenticationCode", "invalid-code", "pending"].includes(magicAuthenticationStatus);
      var shouldUpdateState = walletDialogState !== "authenticationCode" && (isAuthCodeRelated || magicAuthenticationStatus === "unauthenticated");
      if (shouldUpdateState) {
        restartMagicLinkStatus();
        updateWalletDialogState(isConnected ? "connected" : "logIn");
      }
    }
  }, []);
  var content = useMemo(function () {
    if (publicKey) {
      return getPublicAddress(publicKey.toBase58());
    }
    return t("connectWallet.connectButton");
  }, [publicKey, t]);
  var handleOpenDialog = function handleOpenDialog() {
    setOpen(true);
  };
  var restartMagicLinkStatus = useCallback(function () {
    if (magicAuthenticationStatus === "errored") restartSession();
  }, [restartSession, magicAuthenticationStatus]);
  return /*#__PURE__*/React.createElement(Fragment, null, isSmallScreen && compresedView ? /*#__PURE__*/React.createElement(IconButton, _extends({
    id: "connect-wallet-button",
    onClick: handleOpenDialog,
    "aria-haspopup": "true",
    size: "medium"
  }, rest), /*#__PURE__*/React.createElement(WalletOutline, null)) : /*#__PURE__*/React.createElement(Button, _extends({
    startIcon: /*#__PURE__*/React.createElement(SolanaWallet, {
      wallet: wallet
    }),
    onClick: handleOpenDialog,
    "aria-haspopup": "true",
    size: "large",
    id: "connect-wallet-button"
  }, rest), content), /*#__PURE__*/React.createElement(ConnectDialog, {
    open: open,
    handleClose: handleClose,
    disableMagicLink: disableMagicLink,
    logo: logo,
    connectLabel: connectLabel
  }));
};

var SolanaRPCProvider = function SolanaRPCProvider(_ref) {
  var solanaRpcHost = _ref.solanaRpcHost,
    children = _ref.children;
  return /*#__PURE__*/React$1.createElement(SolanaRPCContext.Provider, {
    value: solanaRpcHost
  }, children);
};

var translation = {
  generic: {
    connectWallet: "Please connect your wallet",
    comingSoon: "Coming Soon",
    noResults: "No matches found.",
    error: {
      message: "Failed to load.",
      buttonTitle: "Retry"
    }
  },
  connectWallet: {
    connectButton: "Connect",
    authenticateCode: {
      error: "Wrong pin",
      title: "Please enter the code sent to"
    },
    connected: {
      copyAddress: "Copy address",
      changeWallet: "Change Wallet",
      disconnect: "Disconnnect",
      openWallet: "Open wallet"
    },
    email: {
      error: "Type a valid email",
      submit: "Submit",
      title: "Continue with email"
    },
    login: {
      email: "Connect with email",
      wallet: "Connect with wallet",
      title: "Connect to DeWiCats"
    },
    wallets: {
      lessOptions: "Less options",
      moreOptions: "More options",
      title: "Select your Solana wallet to continue.",
      connected: "Connected",
      detected: "Detected",
      notDetected: "Not detected"
    }
  }
};

var lang = "en";
void i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translation
    }
  },
  lng: lang,
  fallbackLng: ["en"]
});
var useLanguage = function useLanguage() {
  var _useState = useState("en"),
    _useState2 = _slicedToArray(_useState, 2),
    language = _useState2[0],
    setLanguage = _useState2[1];
  useAsync(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return initLanguage();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, []);
  var changeLanguage = useCallback(function (lang) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setLanguage(lang);
            _context2.next = 3;
            return i18n.changeLanguage(lang);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }, []);
  var initLanguage = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 3;
            return changeLanguage(lang);
          case 3:
            setLanguage(lang);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  }, [changeLanguage]);
  return {
    language: language,
    changeLanguage: changeLanguage
  };
};

var initialState = {
  language: "en",
  changeLanguage: function changeLanguage() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }
};
var LanguageContext = /*#__PURE__*/createContext(initialState);
var Provider = LanguageContext.Provider;
var LanguageProvider = function LanguageProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React$1.createElement(Provider, {
    value: useLanguage()
  }, children);
};

var defaultWallets = [new PhantomWalletAdapter(), new SolflareWalletAdapter()];
var ConnectButtonProvider = function ConnectButtonProvider(_ref) {
  var solanaRpcHost = _ref.solanaRpcHost,
    magicKey = _ref.magicKey,
    _ref$wallets = _ref.wallets,
    wallets = _ref$wallets === void 0 ? defaultWallets : _ref$wallets,
    children = _ref.children;
  var connection = useMemo(function () {
    return new Connection(solanaRpcHost, {
      commitment: "confirmed"
    });
  }, [solanaRpcHost]);
  var renderChildrenProviders = function renderChildrenProviders() {
    return /*#__PURE__*/React.createElement(ConnectWalletProvider, null, /*#__PURE__*/React.createElement(SolanaRPCProvider, {
      solanaRpcHost: solanaRpcHost
    }, children));
  };
  return /*#__PURE__*/React.createElement(LanguageProvider, null, /*#__PURE__*/React.createElement(ConnectionProvider, {
    endpoint: connection.rpcEndpoint
  }, /*#__PURE__*/React.createElement(WalletProvider, {
    wallets: wallets,
    autoConnect: true
  }, magicKey ? /*#__PURE__*/React.createElement(MagicProvider, {
    magicKey: magicKey,
    solanaRpcHost: solanaRpcHost
  }, renderChildrenProviders()) : renderChildrenProviders())));
};

var useUserSolana = function useUserSolana() {
  var _useSolana = useSolana(),
    publicKey = _useSolana.publicKey,
    connecting = _useSolana.connecting,
    connected = _useSolana.connected,
    magicAuthenticationStatus = _useSolana.magicAuthenticationStatus,
    magic = _useSolana.magic,
    anchorProvider = _useSolana.anchorProvider,
    autoConnect = _useSolana.autoConnect,
    wallet = _useSolana.wallet,
    disconnecting = _useSolana.disconnecting,
    select = _useSolana.select,
    connect = _useSolana.connect,
    disconnect = _useSolana.disconnect,
    signAllTransactions = _useSolana.signAllTransactions,
    signMessage = _useSolana.signMessage,
    signIn = _useSolana.signIn,
    sendTransaction = _useSolana.sendTransaction;
  return {
    publicKey: publicKey,
    connecting: connecting,
    connected: connected,
    magicAuthenticationStatus: magicAuthenticationStatus,
    magic: magic,
    anchorProvider: anchorProvider,
    autoConnect: autoConnect,
    wallet: wallet,
    disconnecting: disconnecting,
    select: select,
    connect: connect,
    disconnect: disconnect,
    signAllTransactions: signAllTransactions,
    signMessage: signMessage,
    signIn: signIn,
    sendTransaction: sendTransaction
  };
};

export { ConnectButtonProvider, ConnectButton as default, useUserSolana as useSolana };
//# sourceMappingURL=index.js.map
